import { render, staticRenderFns } from "./private.vue?vue&type=template&id=159e6c1e&scoped=true&"
import script from "./private.vue?vue&type=script&lang=js&"
export * from "./private.vue?vue&type=script&lang=js&"
import style0 from "./private.vue?vue&type=style&index=0&id=159e6c1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159e6c1e",
  null
  
)

export default component.exports